import styled from "styled-components"

export const ContactStyles = styled.section`
  max-width: 720px;
  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;

  .hidden-field {
    display: none;
  }

  .field {
    display: block;
    margin-bottom: var(--gap);
  }

  .field__label {
    display: block;
    font-family: var(--font-sans);
    font-size: var(--text-kicker);
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--color-gold-500);
    margin-bottom: 0.7rem;
  }

  input,
  textarea {
    background-color: var(--color-coal);
    color: var(--color-paper);
    border: 1px solid var(--color-line);
    border-radius: 12px;
    width: 100%;
    font-size: var(--p);
    font-family: var(--font-sans);
    padding: 16px;
    transition: border-color 0.3s var(--ease-power);

    &:focus {
      outline: none;
      border-color: var(--color-gold-500);
    }

    &::placeholder {
      color: var(--color-faint);
    }
  }

  input {
    height: calc(var(--gap) * 1.6);
  }

  textarea {
    resize: vertical;
    min-height: 160px;
  }

  .btn {
    margin-top: calc(var(--gap) / 2);
  }
`
